import { Component } from '@angular/core';
import { users } from 'src/app/models/Login';
import { Lista_Historial_Visitas, Reporte_Paises } from 'src/app/models/QR';
import { QrService } from 'src/app/service/qr.service';
import { StorageService } from 'src/app/service/storage.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent {

  esAdministrado: boolean = false;
  singleaa: any[] = [];
  List_Historial_x_Pais: Lista_Historial_Visitas[] = [];
  List_Cantidad_Visitas : Reporte_Paises[] = [];

  public usuario: users | undefined;
  nombres: string | undefined;
  rol: string | undefined;
  cantidad_registro: number  = 0;
  
  Highcharts: typeof Highcharts = Highcharts;

  // Paleta de marca (rojo Claro + tonos neutros) en vez de los colores
  // arcoíris por defecto de Highcharts.
  private readonly paletaGrafico = ['#DA291C', '#F26A5B', '#F2A488', '#8C1A12', '#5F6368', '#91979E', '#C9CCD1', '#E7E7E7'];

  chartOptions: Highcharts.Options = {
    chart: {
      type: 'pie',
    },
    title: {
      text: ''
    },
    colors: this.paletaGrafico,
    tooltip: {
      pointFormat: '<b>{point.y}</b> visitas ({point.percentage:.1f}%)'
    },
    plotOptions: {
      pie: {
        innerSize: '60%',
        borderWidth: 2,
        borderColor: '#FFFFFF',
        showInLegend: true,
        dataLabels: {
          enabled: true,
          format: '{point.percentage:.0f}%',
          distance: -28,
          style: { fontWeight: 'bold', fontSize: '11px', textOutline: 'none', color: '#FFFFFF' },
          filter: { property: 'percentage', operator: '>', value: 4 }
        }
      }
    },
    legend: {
      enabled: true,
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      itemStyle: { fontSize: '12px', fontWeight: 'normal' },
      maxHeight: 380
    },
    series: [{
      data: [],
      type: 'pie'
    }]
  };
  

  constructor(private modulesService: QrService,
    private route: Router,
    private storageService: StorageService,
    private toastr: ToastrService) {

  }


  ngOnInit(): void {
     const usuarioStorage = this.storageService.getUsuarioStorage();

     if (!usuarioStorage || Object.keys(usuarioStorage).length === 0) {
      this.route.navigate(['/login']);

      // this.toastr.success('Hello world!', 'Toastr fun!');
    } else {
      this.esAdministrado = this.storageService.esAdministrador();
      this.cargarPantalla_Visita_x_Pais();
      this.cargaLocalStorage();
      this.ListaCantidadVisitas();
      this.cargacantidadregistros();
    }
  }



  // options
  gradient: boolean = true;
  showLegend: boolean = true;
  showLabels: boolean = true;
  isDoughnut: boolean = false;


  colorScheme = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };




  updateChartOptions1() {
    // Agrupa los países con menos visitas en "Otros" para que el gráfico
    // no se llene de etiquetas diminutas superpuestas.
    const MAX_SLICES = 7;
    const ordenado = [...this.List_Historial_x_Pais]
      .map(item => ({ name: item.name ?? '', y: item.y ?? 0 }))
      .sort((a, b) => b.y - a.y);

    const principales = ordenado.slice(0, MAX_SLICES);
    const resto = ordenado.slice(MAX_SLICES);
    const otrosTotal = resto.reduce((sum, item) => sum + item.y, 0);

    const data = otrosTotal > 0
      ? [...principales, { name: `Otros (${resto.length})`, y: otrosTotal }]
      : principales;

    this.chartOptions.series = [{
      type: 'pie',
      data: data,
    }];

    // Renderiza el gráfico con las nuevas opciones
    Highcharts.chart('container1', this.chartOptions);
  }


  cargaLocalStorage() {
    this.usuario = this.storageService.getUsuarioStorage();
    this.nombres = this.usuario?.nombre;
    this.rol = this.usuario?.rol;
  }




  onSelect(data: any): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data: any): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data: any): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }


  async cargarPantalla_Visita_x_Pais() {
    try {
      const data = await new Promise((resolve, reject) => {
        this.modulesService.Lista_Reporte(0, 1).subscribe(
          data => {
            //     console.log('DATA:' + JSON.stringify(data));
            this.List_Historial_x_Pais = data;
             this.updateChartOptions1();
          },
          error => {
            reject(error);
          }
        );
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }


  async ListaCantidadVisitas(){
    this.modulesService.Lista_Cantidad_Visitas_x_Pais().subscribe(
        data => {
          // Orden descendente por cantidad de visitas: el país con más
          // escaneos aparece primero (#1), como corresponde a un ranking.
          this.List_Cantidad_Visitas = [...data].sort((a, b) => b.count_cantidad - a.count_cantidad);
          this.cantidad_registro = this.List_Cantidad_Visitas.reduce((sum, current) => sum + current.count_cantidad, 0);
        }

    )

  }

  async cargacantidadregistros(){
    this.List_Cantidad_Visitas.forEach(element => {
      this.cantidad_registro = this.cantidad_registro+  element.count_cantidad;
    });
  }

}
